import { render, staticRenderFns } from "./pcHome.vue?vue&type=template&id=51ecbf53"
import script from "./pcHome.vue?vue&type=script&lang=js"
export * from "./pcHome.vue?vue&type=script&lang=js"
import style0 from "./pcHome.vue?vue&type=style&index=0&id=51ecbf53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports